import { useRouter } from "next/router";
import { parse as parseQS } from "qs";

export function useSearchParams() {
    const router = useRouter();
    const { pathname, asPath } = router;

    return parseQS(asPath.replace(pathname, ""), { ignoreQueryPrefix: true });
}
